// import changeBoxToolButtons from './changeBoxToolButtons';
// import changeColumnToolButtons from './changeColumnToolButtons';
// import changeElmToolButtons from './changeElementToolButtons';
// import changeRowToolButtons from './changeRowToolButtons';
// import changeSectionToolButtons from './changeSectionToolButtons';

// changeColumnToolButtons();
// changeRowToolButtons();
// changeBoxToolButtons();
// changeSectionToolButtons();
// changeElmToolButtons();

(window as any).applyEditorChanges = () => {
  // (window as any).changeAllBoxEdit?.();
  // (window as any).changeAllCellMore?.();
  // (window as any).changeElmOptions?.();
  // (window as any).changeAllRowMore?.();
  // (window as any).changeAllSectionEdit?.();
};

window.commUtilsTrigger = function () {
  if(window === parent) {
    return;
  }
  parent.commUtilsTrigger?.(...arguments);
};

document.addEventListener('selectionchange', (event) => {
  const selection = document.getSelection();
  const btnLink = parent.document.querySelector('.panel-text .btn-link') as
    | HTMLButtonElement
    | HTMLAnchorElement
    | null;
  if (selection?.focusOffset === selection?.anchorOffset) {
    if (btnLink) {
      btnLink.style.display = 'none';
    }
  } else {
    if (btnLink) {
      btnLink.style.display = 'initial';
    }
  }
});

document.addEventListener('click', (e) => {
  if (
    // window.location.hostname.includes('learnyst.com') ||
    window.location.hostname.includes('localhost:3001') ||
    window.location.hostname.includes('res-cdn.learnyst.com') ||
    window.location.hostname.includes('cloudfront.net') ||
    window.location.pathname === 'srcdoc'
  ) {
    e.preventDefault();
    return;
  }
  if ((e.target as HTMLElement).tagName.toLowerCase() === 'a') {
    const href = (e.target as HTMLAnchorElement)?.getAttribute('href');
    if (!href?.includes('#cta-id=')) {
      return;
    }
    const id = href.split('#cta-id=')[1] || 0;
    const ctaWithId = document.querySelector(`lyst-cta-popup[cta-id="${id}"]`);
    if (ctaWithId) {
      ctaWithId.remove();
    }
    const cta = document.createElement('lyst-cta-popup');
    cta.setAttribute('cta-id', id.toString());
    cta.setAttribute('show', 'true');
    document.body.append(cta);
    e.preventDefault();
  }
});

const attachButtonCTAs = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isDesignerMode = !!queryParams.get('isDesignerMode');
  document.querySelector('embed-container')?.querySelectorAll('lyst-cta-embed-button').forEach(el => {
    el.remove();
  })
  document.querySelectorAll('a').forEach(el => {
    if(el.href.includes('#cta-button-id')) {
      const ctaId = el.href.split('=')[1];
      const lystCtaEmbedButton = document.createElement('lyst-cta-embed-button');
      lystCtaEmbedButton.setAttribute('external-button', 'true');
      lystCtaEmbedButton.setAttribute('cta-id', ctaId);
      document.querySelector('embed-container')?.appendChild(lystCtaEmbedButton);
      if(!isDesignerMode) {
        const interval = setInterval(() => {
          if(!lystCtaEmbedButton.renderRoot) {
            return;
          } 
          clearInterval(interval);
          lystCtaEmbedButton.buttonElement = el;
        }, 200);
      }
    }
  })
}

const addCTAManager = () => {
  if (
    window.location.hostname.includes('res-cdn.learnyst.com') ||
    window.location.hostname.includes('cdn-learnyst.learnyst.com') ||
    window.location.hostname.includes('cloudfront.net') ||
    window.location.pathname === 'srcdoc'
  ) {
    return;
  }
  const ctaManager = document.createElement('bodhi-cta-manager');
  document.body.appendChild(ctaManager);
};

const interval = setInterval(() => {
  if (!(window as any).schoolId) {
    return;
  }
  clearInterval(interval);
  attachButtonCTAs();
  addCTAManager();
}, 500);

if (
  window.location.hostname.includes('res-cdn.learnyst.com') || 
  window.location.hostname.includes('localhost:3001') ||
  window.location.pathname === 'srcdoc'
) {
  if (parent.builderConfig?.css?.previewIframe) {
    const styles = document.createElement('style');
    styles.innerHTML = parent.builderConfig.css.previewIframe;
    document.body.appendChild(styles);
  }
}

if (!customElements.get('lyst-widget-wrapper')) {
  import('../lystCustomElements/lystWidgetWrapper');
}
